'use strict'

import Failed from '../../lib/Failed';

class VerifyAccount {
    
    constructor() {
        
    }

    init () {
        $('input[name="verification"]').on('click', function (e) {
            $('#btn-following').removeClass('disabled');
        });
        $('#btn-following').on('click', (e) => {
            e.preventDefault();
            if (parseInt($('input[name="verification"]:checked').val()) === 3){
                this.verifyAccountBySms();
                $('#btn-following').addClass('disabled');
            }
            if (parseInt($('input[name="verification"]:checked').val()) === 1){
                this.verifyAccountByEMail();
                $('#btn-following').addClass('disabled');
            } else {
                //return window.location = App.baseUrl + '/panel/fecha-de-nacimiento';
            } 
        });
    }

    verifyAccountByEMail () {
        fetch(App.baseUrl + '/panel/ajax/verificar-por-email', {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            }
        })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 0){
                return Failed.show({
                    'title':'Ocurrió un error',
                    'description':data.message,
                    'link':{
                        title:'Reintentar',
                        href:App.baseUrl + '/panel/crear-cuenta'
                    }
                });
            }
            if (data.status === 0){
                return Failed.show({
                    'title':'Tu cédula no existe en el listado<br> de AFAP Itaú.',
                    'description':'Tu cédula no existe en el listado<br> de AFAP Itaú.',
                    'link':{
                        title:'Reintentar',
                        href:App.baseUrl + '/panel/crear-cuenta'
                    }
                });
            }
            if (data.status === 2){
                return Failed.show(data.message);
            }
            if (data.status === 1){
                return window.location = App.baseUrl + '/panel/verifica-tu-email';
            }
        });
    }

    verifyAccountBySms () {
        fetch(App.baseUrl + '/panel/ajax/verificar-por-sms', {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            }
        })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 0){
                return Failed.show({
                    'title':'Ocurrió un error',
                    'description':data.message,
                    'link':{
                        title:'Reintentar',
                        href:App.baseUrl + '/panel/verificar-sms'
                    }
                });
            }
            if (data.status === 0){
                return Failed.show({
                    'title':'Error enviando validación por sms.',
                    'description':'No se ha podido enviar el mensaje.',
                });
            }
            if (data.status === 2){
                return Failed.show(data.message);
            }
            if (data.status === 1){
                return window.location = App.baseUrl + '/panel/verificar-sms';
            }
        });
    }

}

export default VerifyAccount;